<template>
  <div class="downloads page pb-12">
    <div class="downloads__background"></div>
    <img
      width="50"
      src="../assets/img/illustrations/cloud.svg"
      class="cloud-illustration"
    />
    <div class="container">
      <SectionHeader
        title="Ke stažení"
        text="<p>V této sekci najdete všeobecné materiály věnované cukrovce nebo obezitě. Všechny tyto materiály si můžete bezplatně stáhnout do svého počítače či telefonu.</p><p>Pokud užíváte léky na cukrovku nebo obezitu od společnosti Novo Nordisk, můžete se přihlásit do uzavřené sekce <a href='/prihlaseni' class='text-decoration-underline font-weight-bold'>Pro pacienty</a>, kde najdete více informací i přímo k Vaší léčbě.</p>"
      />

      <div class="card-wrapper">
        <img
          v-if="$vuetify.breakpoint.mdAndUp"
          width="70"
          src="../assets/img/illustrations/human.svg"
          class="human-illustration"
        />
        <v-tabs grow v-model="tab">
          <v-tab v-for="(item, index) in items" :key="index">
            <h3>{{ item.title }}</h3>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(item, index) in items"
            :key="index"
            :value="index"
          >
            <div class="primary--text pa-6">
              <h1 class="mb-4">Ke stažení {{ item.title }}</h1>
              <div>
                <div v-if="item.value === 'diabetes'">
                  <p>
                    V této sekci najdete veškeré všeobecné materiály věnované
                    cukrovce 1. a 2. typu, ale také gestační diabetes, návody na
                    chytrá inzulinová pera a další. Všechny materiály si můžete
                    bezplatně stáhnout.
                  </p>
                  <p>
                    Pokud užíváte léky na cukrovku od společnosti Novo Nordisk,
                    můžete se přihlásit do uzavřené sekce
                    <span
                      class="text-decoration-underline font-weight-bold cursor-pointer"
                      @click="$router.push('/prihlaseni')"
                    >
                      Pro pacienty </span
                    >, kde najdete více informací i přímo k Vaší léčbě.
                  </p>
                </div>
                <div class="primary--text" v-if="item.value === 'obesity'">
                  <p>
                    V této sekci najdete veškeré všeobecné materiály věnované
                    nadváze či obezitě. Všechny materiály si můžete bezplatně
                    stáhnout.
                  </p>
                  <p>
                    Pro více informací o nadváze či obezitě přejděte na stránky
                    <a
                      href="http://netloustneme.cz"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-decoration-underline font-weight-bold"
                    >
                      Netloustneme.cz
                    </a>
                    . Pokud užíváte léky na na obezitu od společnosti Novo
                    Nordisk, můžete se přihlásit do uzavřené sekce
                    <span
                      class="text-decoration-underline font-weight-bold cursor-pointer"
                      @click="$router.push('/prihlaseni')"
                      >Pro pacienty</span
                    >, kde najdete více informací i přímo k Vaší léčbě.
                  </p>
                </div>
              </div>

              <DownloadCardGrid
                class="mt-12"
                :cards="
                  cards.filter((card) =>
                    card.diseases.includes(item.value.toLowerCase())
                  )
                "
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadCardGrid from "../components/DownloadCardGrid.vue";
import SectionHeader from "../components/SectionHeader.vue";
import Downloads from "../data/downloads.json";

export default {
  components: { DownloadCardGrid, SectionHeader },
  data() {
    return {
      cards: Downloads,
      tab: "",
      items: [
        { value: "diabetes", title: "Diabetes" },
        { value: "obesity", title: "Obezita" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.downloads {
  position: relative;
  background: var(--v-primary-base);
  min-height: 100vh;
  &__background {
    background: var(--v-bgLight-base);
    height: calc(90%);
    width: 100%;
    position: absolute;
    left: 0;
    top: -5rem;
  }

  .v-tab--active {
    color: white !important;
    background-color: var(--v-primary-base) !important;
  }

  .card-wrapper {
    position: relative;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

    .human-illustration {
      position: absolute;
      left: -3.5rem;
      top: -3.5rem;
    }
  }

  .cloud-illustration {
    position: absolute;
    left: 50%;
    top: -2.5rem;
    transform: translate(-50%);
  }
}
</style>
